// import img1 from '../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg';
import img2 from '../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg';
import img3 from '../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg';
import img4 from '../../assets/store/amazing-suggest/jonny-gios-gBr5Hmx1STc-unsplash.jpg';
import img5 from '../../assets/store/amazing-suggest/jeremy-thomas-O6N9RV2rzX8-unsplash.jpg';
import img6 from '../../assets/store/amazing-suggest/juja-han-HU-uL54pfQI-unsplash.jpg';
import img7 from '../../assets/store/amazing-suggest/alex-kondratiev-H9t723yPjYI-unsplash.jpg';
import img8 from '../../assets/store/amazing-suggest/phil-botha-a0TJ3hy-UD8-unsplash.jpg';
import img9 from '../../assets/store/amazing-suggest/lidye-1Shk_PkNkNw-unsplash.jpg';
import avatar1 from "../../assets/azmoon-list/tushar-khandagale-dvtAuBHBAVQ-unsplash.jpg";
import video1 from "../../assets/store/video.mp4";
import video_cover1 from '../../assets/store/element5-digital-OyCl7Y4y0Bk-unsplash.jpg';

let intial_state = [
  {
    id:1,
    id2:1,
    img:img8,
    name:"آزمون نجوم نظری",
    // price:458.200,
    masterPrice:450200,
    price:405000,
    badge:"10%",
    date:"2021-10-26T12:00:00.180Z",
    endDate:"2021-10-27T12:00:00.180Z",
    level:"کارشناسی ارشد",
    type:1,          //c     فردی ، گروهی 
    time_type:"future",    //c    دسته بندی زمانی آزمونها برای قرار دادن در داشبرد :"future","live","thisWeek"
    filter: "collegiate",  //c فیلتر کردن آزمون ها با کلیدهای فیلتر در فروشگاه و 
    count:100,      
    capacity:120,   
    exam_filter:"collegiate",        //حذف شود
    negattiveMode:true,  //c   نمره منفی
    types:"تشریحی و تستی",         //c نوع سولات
    guideFileId:"#",
    text:"از فصل دوم تا چهارم",   //c    توضیحی کوتاه که در صفحه آزمون استفاده میشود
    duratin:60,                     //مدت زمان آزمون بر حسب دقیقه
    creator:{                      //اطلاعات ایجاد کننده آزمون
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",   //c  اطلاعاتی که در صفحه خرید آزمون استفاده میشود.
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],          //اطلاعاتی دیگری که در صفحه خرید آزمون استفاده میشود
    video:video1,   //ویدیویی درباره آزمون که در صفحه خرید استفاده میشود
    video_cover:video_cover1,
    files:[         //فایل های مورد نیاز برای آمادگی آزمون که در صفحه خرید استفاده میشود
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  },
  {
    id:2,
    id2:2,
    img:img4,
    name:"آزمون جغرافیای جهان",
    // price:458.200,
    masterPrice:340000,
    price:306000,
    badge:"10%",
    date:"2021-10-18T12:00:00.180Z",
    endDate:"2021-10-19T12:00:00.180Z",
    level:"پایه دهم",
    type:2,
    time_type:"thisWeek",
    filter: "discounted",
    exam_filter:"live",
    count:100,      
    capacity:120,
    negattiveMode:true,
    types:"تشریحی و تستی",
    guideFileId:"#",
    text:"از فصل سوم تا پنجم",
    duratin:60,
    creator:{
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],
    video:video1,
    video_cover:video_cover1,
    files:[
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  },
  {
    id:3,
    id2:3,
    img:img5,
    name:"آزمون رنگ‌شناسی",
    // price:458.200,
    masterPrice:100000,
    price:90000,
    badge:"10%",
    date:"2021-10-15T12:00:00.180Z",
    endDate:"2021-10-17T12:00:00.180Z",
    level:"کارشناسی",
    type:1,
    time_type:"future",
    filter: "discounted",
    count:100,      
    capacity:120,
    exam_filter:"live",
    negattiveMode:true,
    types:"تشریحی و تستی",
    guideFileId:"#",
    text:"از فصل سوم تا پنجم",
    duratin:60,
    creator:{
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],
    video:video1,
    video_cover:video_cover1,
    files:[
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  },
  {
    id:4,
    id2:4,
    img:img3,
    name:"آزمون روان درمانی اگزیستانسیال",
    // price:458.200,
    masterPrice:200000,
    price:180000,
    discount:"10%",
    date:"2021-10-25T12:00:00.180Z",
    endDate:"2021-10-26T12:00:00.180Z",
    level:"پایه 1 الی 12",
    type:1,
    time_type:"live",
    filter: "none",
    count:100,      
    capacity:120,
    exam_filter:"live",
    negattiveMode:false,
    types:"تشریحی و تستی",
    guideFileId:"#",
    text:"از فصل سوم تا پنجم",
    duratin:60,
    creator:{
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],
    video:video1,
    video_cover:video_cover1,
    files:[
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  },
  {
    id:5,
    id2:5,
    img:img6,
    name:"آزمون موسیقی‌شناسی",
    // price:458.200,
    masterPrice:200000,
    price:"",
    badge:"",
    date:"2021-10-26T12:00:00.180Z",
    endDate:"2021-10-27T12:00:00.180Z",
    level:"پایه 5 الی 12",
    time_type:"live",
    type:1,
    filter: "none",
    count:100,      
    capacity:120,
    exam_filter:"live",
    negattiveMode:true,
    types:"تشریحی و تستی",
    guideFileId:"#",
    text:"از فصل سوم تا پنجم",
    duratin:60,
    user_num:100,
    creator:{
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],
    video:video1,
    video_cover:video_cover1,
    files:[
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  },
  {
    id:6,
    id2:6,
    img:img7,
    name:"آزمون شیمی یازدهم",
    // price:458.200,
    masterPrice:200000,
    price:180000,
    badge:"10%",
    date:"2021-10-28T12:00:00.180Z",
    endDate:"2021-10-28T12:00:00.180Z",
    level:"پایه 11",
    type:1,
    time_type:"thisWeek",
    filter: "none",
    count:100,      
    capacity:120,
    exam_filter:"collegiate",
    negattiveMode:true,
    types:"تشریحی و تستی",
    guideFileId:"#",
    guide_file_link:"#",
    text:"از فصل سوم تا پنجم",
    duratin:60,
    creator:{
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],
    video:video1,
    video_cover:video_cover1,
    files:[
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  },
  {
    id:7,
    id2:7,
    img:img9,
    name:"آزمون آشپزی ملل",
    // price:458.200,
    masterPrice:200000,
    price:"",
    discount:"",
    date:"2021-11-05T12:00:00.180Z",
    endDate:"2021-11-06T12:00:00.180Z",
    level:"عمومی",
    type:2,
    time_type:"thisWeek",
    filter: "none",
    count:100,      
    capacity:120,
    exam_filter:"collegiate",
    negattiveMode:true,
    types:"تشریحی و تستی",
    guideFileId:"#",
    text:"از فصل سوم تا پنجم",
    duratin:60,
    creator:{
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],
    video:video1,
    video_cover:video_cover1,
    files:[
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  },
  {
    id:8,
    id2:8,
    img:img2,
    name:"آزمون گسسته",
    // price:458.200,
    masterPrice:200000,
    price:0,
    badge:"100%",
    date:"2021-11-17T12:00:00.180Z",
    endDate:"2021-11-18T12:00:00.180Z",
    level:"پایه 10",
    type:1,
    time_type:"future",
    filter: "free",
    count:100,      
    capacity:120,
    exam_filter:"collegiate",
    negattiveMode:true,
    types:"تشریحی و تستی",
    guideFileId:"#",
    text:"از فصل سوم تا پنجم",
    duratin:60,
    user_num:100,
    creator:{
      avatar:avatar1,
      name:"موسسه فرهنگی مصباح نور"
    },
    descripton:"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time:"21:30",
    html:[
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد"
    ],
    video:video1,
    video_cover:video_cover1,
    files:[
      [
        {
          id:1,
          text:"دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path:"#"
        }
      ],
      [
        {
          id:1,
          text:"دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path:"#"
        },
        {
          id:2,
          text:"دریافت نرم افزار پخش ویدیو",
          path:"#"
        }
      ]
    ]
  }
]


const Exam_Data_reducer=(state = intial_state, action)=>{
  switch (action.type) {
    case "nothing":
      return state;
    default:
      return state;
  }
}

export default Exam_Data_reducer;